import React,{Fragment} from 'react';
import {
  Card, CardBody, Button
} from 'reactstrap';
import ReactTable from "react-table";
import { withTranslation } from 'react-i18next';
import { Spinner } from 'reactstrap';

class EmailTemplateTable extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      emailTemplateList: this.props.emailTemplateList,
      isLoaded: this.props.isLoaded
    }
  }
  componentWillReceiveProps(props){
    console.log('Properties Changed '+ props.isLoaded);
    this.setState({
      emailTemplateList: props.emailTemplateList,
      isLoaded: props.isLoaded
    })
  }
  render(){
    const { t, i18n } = this.props;
    return (
      <CardBody>
      {this.state.isLoaded ? <ReactTable
      columns={[
        {
          Header: t("email_template.name"),
          accessor : 'name'
        },
        {
          Header: t("email_template.last_modified_date"),
          accessor : 'modified_date',
        },
        {
          /* TODO: Replace inline style class with CSS class */
          Header: "Actions",
          Cell: ({row}) => (
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <Button className="mb-2 mr-2 btn-icon btn-shadow" size="md" color="success" onClick={() => this.props.onEditOrCopy(row._original)}>
                <i className="lnr-pencil btn-icon-wrapper mx-auto"> </i>
              </Button>
              <Button className="mb-2 mr-2 btn-icon btn-shadow" size="md" color="success" onClick={() => this.props.onEditOrCopy(row._original, true)}>
                <i className="pe-7s-copy-file btn-icon-wrapper mx-auto"> </i>
              </Button>
              <Button className="mb-2 mr-2 btn-icon btn-shadow" size="md" color="success" onClick={() => this.props.onDelete(row)}>
                <i className="pe-7s-trash btn-icon-wrapper mx-auto"> </i>
              </Button>
            </div>
          )
        }]}
      data={this.state.emailTemplateList}
      showPageSizeOptions={false}
      defaultPageSize={10}
      pageSize={this.state.emailTemplateList.length}
      className="-striped -highlight"
      /> : <div><Spinner color="primary" /> Data is loading!!!</div>}
    </CardBody>)
  }
}

export default withTranslation()(EmailTemplateTable);
